import { useTranslation } from 'react-i18next'
import { useConfirmStore } from '@/hooks/useConfirmStore'
import { Dialog } from './Dialog'
import { Button } from './Button'

export function ConfirmDialog() {
  const { t } = useTranslation()
  const { open, title, message, hide, confirm } = useConfirmStore()

  return (
    <Dialog
      open={open}
      title={title}
      onClose={hide}
      onConfirm={confirm}
      footer={(
        <>
          <Button variant="ghost" onClick={hide}>
            {t('common.cancel')}
          </Button>
          <Button variant="danger" onClick={confirm}>
            {t('common.confirm')}
          </Button>
        </>
      )}
    >
      <div
        className="max-h-[240px] overflow-y-auto pr-1"
        style={{ scrollbarGutter: 'stable' }}
      >
        <p
          className="whitespace-pre-wrap break-words text-sm"
          style={{ color: 'var(--text-muted)' }}
        >
          {message}
        </p>
      </div>
    </Dialog>
  )
}
